<template>
  <div class="modal_card reverse">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>{{ modalInfo.header }}</h1>
      <form @submit.prevent="submitUser">
        <b-collapse
          animation=""
          v-for="(user, i) in newUsers"
          :key="i"
          :open="isOpen"
          aria-id="modal-users-list"
          class="modal-users-list"
        >
          <div @click="open" class="list_header users active" slot="trigger" aria-controls="modal-users-list">
            <span class="left"> <i class="icon-button-arrow"></i>Пользователь - {{ i + 1 }} </span>
            <span class="delete-button" @click="$emit('remove-user', i)">
              <i class="mdi mdi-delete"></i>
            </span>
          </div>
          <b-field
            label="Имя:"
            type="is-info"
            class="left_input has_icon"
            :message="errors.first('name' + i)"
            :class="errors.first('name' + i) ? 'error' : ''"
          >
            <b-input
              placeholder="Имя"
              v-model="user.name"
              :name="'name' + i"
              icon="mdi mdi-account"
              v-validate="{ required: true, min: 2, max: 20 }"
            ></b-input>
          </b-field>
          <b-field
            label="Фамилия:"
            type="is-info"
            class="right_input has_icon"
            :message="errors.first('surname' + i)"
            :class="errors.first('surname' + i) ? 'error' : ''"
          >
            <b-input
              placeholder="Фамилия"
              v-model="user.surname"
              :name="'surname' + i"
              icon="mdi mdi-account"
              v-validate="{ required: true, min: 2, max: 20 }"
            ></b-input>
          </b-field>
          <b-field
            label="Отчество:"
            type="is-info"
            class="left_input has_icon"
            :message="errors.first('patronymic' + i)"
            :class="errors.first('patronymic' + i) ? 'error' : ''"
          >
            <b-input
              placeholder="Отчество"
              v-model="user.patronymic"
              :name="'patronymic' + i"
              icon="mdi mdi-account"
              v-validate="{ required: true, min: 2 }"
            ></b-input>
          </b-field>
          <b-field
            label="Должность:"
            type="is-info"
            class="right_input has_icon"
            :message="errors.first('position' + i)"
            :class="errors.first('position' + i) ? 'error' : ''"
          >
            <b-input
              placeholder="Должность"
              v-model="user.position"
              :name="'position' + i"
              icon="mdi mdi-account-tie"
              v-validate="{ required: true, min: 2 }"
            ></b-input>
          </b-field>
        </b-collapse>
        <div class="add-user" @click="addUser">Добавить нового пользователя</div>
        <button class="add_user_button modal_button left_button" :disabled="errors.items.length > 0">
          {{ modalInfo.button }}
        </button>
        <button @click="$emit('close-modal')" class="close_button modal_button right_button">Отмена</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modalInfo: {
      default: () => {},
      type: Object
    },
    newUsers: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      isLoading: false,
      isOpen: true
    }
  },
  methods: {
    submitUser() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit(this.modalInfo.action)
        }
      })
    },
    open(e) {
      if (e.currentTarget.classList.contains('active')) {
        e.currentTarget.classList.remove('active')
      } else {
        e.currentTarget.classList.add('active')
      }
    },
    addUser() {
      this.$emit('add-user')
      let dict = {
        custom: {}
      }
      for (let i = 0; i < this.newUsers.length; i++) {
        dict.custom['name' + i] = {
          required: 'Поле не заполнено',
          min: 'Слишком короткое значение',
          max: 'Слишком длинное значение'
        }
        dict.custom['surname' + i] = {
          required: 'Поле не заполнено',
          min: 'Слишком короткое значение',
          max: 'Слишком длинное значение'
        }
        dict.custom['patronymic' + i] = {
          required: 'Поле не заполнено',
          min: 'Слишком короткое значение'
        }
        dict.custom['position' + i] = {
          required: 'Поле не заполнено',
          min: 'Слишком короткое значение'
        }
      }
      this.$validator.localize('ru', dict)
    },
  },
  created() {
    let dict = {
      custom: {}
    }
    for (let i = 0; i < this.newUsers.length; i++) {
      dict.custom['name' + i] = {
        required: 'Поле не заполнено',
        min: 'Слишком короткое значение',
        max: 'Слишком длинное значение'
      }
      dict.custom['surname' + i] = {
        required: 'Поле не заполнено',
        min: 'Слишком короткое значение',
        max: 'Слишком длинное значение'
      }
      dict.custom['patronymic' + i] = {
        required: 'Поле не заполнено',
        min: 'Слишком короткое значение'
      }
      dict.custom['position' + i] = {
        required: 'Поле не заполнено',
        min: 'Слишком короткое значение'
      }
    }
    this.$validator.localize('ru', dict)
  },
  computed: {
    profileInfo() {
      return this.$store.state.auth.currentUser
    }
  }
}
</script>
